module.exports = __webpack_public_path__ + "static/media/logo_interreg_white2.aceac6a4.png";